/*
 * @Description: 代理系统
 * @Author: gao shuai
 * @Date: 2020-05-18 15:20:58
 * @LastEditTime: 2020-08-18 10:48:08
 * @LastEditors: gao shuai
 */

import api from '../services/api';
export default {
  /* --------------------------1.下属员工---------------------------- */
  // 下属员工列表
  async submerchantList(params) {
    return api({ url: '/api/HomePage/GetEmployeeListAsync', method: 'get', params });
  },
  // 员工登录（模仿代理商户登录逻辑，若后端路径不同请调整此 URL）
  async employeeLogin(params) {
    return api({ url: '/api/HomePage/MerchantLoginAsync', method: 'post', data: params });
  },

  // 添加员工
  async addMerchant(params) {
    return api({ url: '/api/UserManage/AddEmployeeAsync', method: 'post', data: params });
  },
// 添加分组
async addteam(params) {
  return api({ url: '/api/UserManage/AddEmployeeTeamAsync', method: 'post', data: params });
},
  // 删除下属员工
  async delMerchant(params) {
    return api({ url: '/api/HomePage/DeleteEmployeeAsync', method: 'post', data: params });
  },
  
  
};
